import { useEffect, type RefObject } from "react";

/**
 * Fecha algo ao clicar fora do elemento `ref`. Só escuta enquanto `active`.
 * Reproduz o padrão já usado em ModelSelector/ExpressionEditor.
 */
export function useClickOutside(
  ref: RefObject<HTMLElement | null>,
  active: boolean,
  onOutside: () => void,
): void {
  useEffect(() => {
    if (!active) return;
    function onDoc(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        onOutside();
      }
    }
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [active, onOutside, ref]);
}
